import { oneLineTrim } from 'common-tags';
import { capitalizeFirstLetter } from './';

const falseyCaseFxn = (word: string): boolean => (word === 'null' || word === 'undefined');

export const getDisplayName = ({ first_name = '', last_name = '' } = {}, locale = 'en-US') => { // TODO: determine how to make this a global function
  // https://stackoverflow.com/questions/59664482/join-the-string-with-same-separator-used-to-split
  const splitter = /([\s|-])/gi;
  const casedFirstNames = first_name.split(splitter).reduce((acc, part) => (acc += splitter.test(part) ? part : capitalizeFirstLetter(part, locale, falseyCaseFxn)), '');
  const casedLastNames = last_name.split(splitter).reduce((acc, part) => (acc += splitter.test(part) ? part : capitalizeFirstLetter(part, locale, falseyCaseFxn)), '');
  return oneLineTrim`${ casedFirstNames } ${ casedLastNames }`;
};